import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Menu, Action, GetActionResponse, GetMenuResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const MENU_URL = `${API_URL}/menu`
const ACTION_URL = `${API_URL}/action`

const getMenus = (query?: string, page: number = 1, limit: number = 10): Promise<Menu[]> => {
  const params = {
    query,
    page,
    limit,
  }

  return axios.get(`${MENU_URL}`, {params}).then((d: AxiosResponse<Menu[]>) => {
    // Mapeie os dados e faça a conversão da propriedade 'acoes' de cada objeto
    const menusWithParsedActions = d.data.map((menu) => ({
      ...menu,
      acoes: typeof menu.acoes === 'string' ? JSON.parse(menu.acoes) : menu.acoes,
    }))

    return menusWithParsedActions
  })
}

const createMenu = (menu: Menu): Promise<Menu> => {
  return axios.post(`${MENU_URL}`, menu).then((d: AxiosResponse<Menu>) => d.data)
}

const updateMenu = (menu: Menu): Promise<Menu> => {
  return axios.patch(`${MENU_URL}/${menu.id}`, menu).then((d: AxiosResponse<Menu>) => d.data)
}

const deleteMenu = (id: ID): Promise<Menu> => {
  return axios.delete(`${MENU_URL}/${id}`).then((d: AxiosResponse<Menu>) => d.data)
}

const getMenuById = (id: ID): Promise<Menu> => {
  return axios.get(`${MENU_URL}/${id}`).then((d: AxiosResponse<Menu>) => d.data)
}

const getActions = (query?: string): Promise<Action[]> => {
  const params = {q: query}

  return axios.get(`${ACTION_URL}`, {params}).then((d: AxiosResponse<GetActionResponse>) => {
    return d.data.data
  })
}

export {getMenus, createMenu, updateMenu, deleteMenu, getMenuById, getActions}
